import { motion } from 'framer-motion';
import { enterUp } from '../../utils/animations';

export function BlogHero() {
    return (
        <section className="bg-navy-900 hero-pattern pt-36 pb-20">
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <motion.div {...enterUp}>
                    <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">Insights</p>
                    <h1 className="font-montserrat font-black text-5xl md:text-6xl text-white tracking-tight leading-tight">Blog</h1>
                    <p className="text-gray-300 text-lg mt-5 max-w-xl leading-relaxed">
                        Clear thinking on VA hiring, business operations, and building sustainable leverage.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
